/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesdroptitle2Inputs */

const en_filesdroptitle2 = /** @type {(inputs: Filesdroptitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop files here or click to choose`)
};

const pt_filesdroptitle2 = /** @type {(inputs: Filesdroptitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largue ficheiros aqui ou clique para escolher`)
};

/**
* | output |
* | --- |
* | "Drop files here or click to choose" |
*
* @param {Filesdroptitle2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesdroptitle2 = /** @type {((inputs?: Filesdroptitle2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesdroptitle2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesdroptitle2(inputs)
	return pt_filesdroptitle2(inputs)
});
export { filesdroptitle2 as "filesDropTitle" }